import itLocale from 'element-ui/lib/locale/lang/it'
import frLocale from 'element-ui/lib/locale/lang/fr'
import esLocale from 'element-ui/lib/locale/lang/es'
import deLocale from 'element-ui/lib/locale/lang/de'

const translations = {
  it_IT: {
    questions: {
      q1: 'Cognome da nubile della madre',
      q2: 'Cognome da nubile della nonna materna',
      q3: 'Città di nascita della madre',
      q4: 'Nome dell\'animale di casa',
      q5: 'Nome della scuola frequentata',
      q6: 'Numero patente di guida',
      q7: 'Data memorabile',
      q8: 'Luogo memorabile'
    },
    status: {
      all: 'Tutte',
      t: 'Terminata',
      0: 'Salvata',
      1: 'Inoltrata al responsabile',
      2: 'Rifiutata dal Responsabile',
      3: 'Approvata',
      4: 'Inoltrata alla Segreteria',
      5: 'Rifiutata dalla Segreteria',
      7: 'Annullata'
    },
    statusDett: {
      0: 'Salvata',
      1: 'Inoltrata',
      2: 'Rifiutata', // 'Rifiutata dal Responsabile',
      3: 'Approvata', // Approvata alla Segreteria',
      4: 'Inoltrata' // Inoltrata alla Segreteria'
    },
    msg: {
      noDocFound: 'Nessun Documento Trovato',
      abort: 'Operazione Annullata'
    },
    placeholder: {
      rangeSeparator: 'al',
      startDate: 'Data dal',
      endDate: 'Data Fine'
    },
    btn: {
      annulla: 'Annulla',
      salva: 'Salva',
      add: 'Aggiungi',
      close: 'Chiudi',
      copyAuto: 'Incolla',
      copy: 'Copia',
      paste: 'Incolla',
      confermaApp: 'Conferma Approvazione',
      confermaRej: 'Conferma Rifiuto',
      approva: 'Approva',
      rifiuta: 'Rifiuta',
      nuova: 'Nuova',
      conferma: 'Conferma',
      cerca: 'Ricerca',
      elimina: 'Elimina',
      sendAll: 'Inoltra Tutto',
      sendResp: 'Inoltra al Responsabile',
      sendSecretary: 'Segreteria',
      seleziona: 'Seleziona',
      filtri: 'Filtri',
      print: 'Stampa',
      closeMonth: 'Chiudi Mese',
      regPresence: 'Registra',
      defActivity: 'Attività Predefinita',
      riapri: 'Riapri',
      convalida: 'Convalida',
      addActivity: 'Aggiungi Attività',
      svuotaCampi: 'Svuota Campi',
      yes: 'Si',
      no: 'No',
      legenda: 'Legenda'
    },
    country: {
      label: 'Paese',
      1: 'Italia',
      2: 'Francia',
      3: 'Spagna',
      4: 'Belgio',
      5: 'Germania',
      L: 'Lussemburgo'
    },
    filtri: {
      selFiltri: 'Filtri di Ricerca',
      mandatory: 'Campi obbligatori',
      selkeyword: 'Inserisci una parola chiave'
    },
    ferie: {
      titolo: 'Richieste',
      titoloAuth: 'Autorizza/Rifiuta',
      titoloCalend: 'Calendario Richieste',
      it_resTt: 'Residuo Fer/Rip',
      it_resGiugno: 'Da fruire Giugno',
      it_resDicembre: 'Da fruire Dicembre',
      fr_resCpNap: 'CP année préc.',
      fr_resCpN: 'CP année cours',
      fr_resRcr: 'RCR',
      fr_resRce: 'RCE',
      es_resVac: 'Vacaciones restantes',
      es_resVacAA: 'Vacaciones año anterior',
      es_resVacAC: 'Vacaciones del año',
      es_resBH: 'Banca ore',
      es_resVac_mobile: 'VAC',
      es_resVacAA_mobile: 'VAC AA',
      es_resVacAC_mobile: 'VAC AC',
      es_resBH_mobile: 'B.H.',
      be_resCpl: 'Conge Legaux JJ',
      be_resCpe: 'Conge Extralegaux JJ',
      be_resRtt: 'RTT HH',
      be_resRhs: 'RHS HH',
      be_resCpl_mobile: 'CPL',
      be_resCpe_mobile: 'CPE',
      be_resRtt_mobile: 'RTT',
      be_resRhs_mobile: 'RHS',
      de_resAc: 'Urlaub',
      de_resAp: 'Urlaub Alt',
      de_resRh1: 'Zeitkonto 1',
      de_resRh2: 'Zeitkonto 2',
      de_resRh3: 'Zeitkonto 3',
      de_resRh4: 'Zeitkonto 4',
      resAc: 'UR',
      resAp: 'UA',
      resRh1: 'Z1',
      resRh2: 'Z2',
      resRh3: 'Z3',
      resRh4: 'Z4',
      tipo: 'Tipologia',
      dal: 'Dal',
      al: 'Al',
      to: 'a',
      dataTo: 'al',
      numOre: 'Num. Ore',
      oreDa: 'Inizio',
      oreA: 'Fine',
      periodo: 'Periodo Richiesto',
      orario: 'Orario',
      stato: 'Stato',
      note: 'Note',
      dip: 'Note Dip.',
      resp: 'Note Resp.',
      noteDip: 'Note del Dipendente',
      noteResp: 'Note del Responsabile',
      ifDelete: 'Confermare l\'eliminazione?',
      attenzione: 'Attenzione',
      nuovaRichiesta: 'Nuova',
      titoloNuovaRichiesta: 'Nuova richiesta di ferie / Permessi',
      tipologia: 'Tipologia',
      dataDa: 'Data dal',
      dataDa_placeholder: 'Data dal',
      dataA: 'al',
      oraInizio: 'Ora di inizio',
      oraFine: 'fine',
      conferma: 'Conferma',
      ifInviaRichiesta: 'Je fractionne mon congé principale pour raison personnelle et je renonce donc aux congés de fractionnement inhérents.',
      si: 'Si',
      no: 'No',
      anno: 'Anno',
      mese: 'Mese',
      vip: 'Vip',
      status: {
        A: 'Inviato',
        C: 'Approvato',
        R: 'Respinto',
        T: 'Tutte',
        A_des: 'Richieste da Autorizzare',
        C_des: 'Richieste Approvate',
        R_des: 'Richieste Respinte',
        T_des: 'Tutte'
      },
      noData: 'Nessun documento trovato',
      errorNoPeriodo: 'Inserisci il periodo di ferie',
      autorizzare: 'Confermi l\'Aturizzazione?',
      rifiutare: 'Confermi il rifiuto?',
      d: 'Giorni',
      h: 'Ore',
      mesi: {
        '01': '{day} gen {year}',
        '02': '{day} feb {year}',
        '03': '{day} mar {year}',
        '04': '{day} apr {year}',
        '05': '{day} mag {year}',
        '06': '{day} giu {year}',
        '07': '{day} lug {year}',
        '08': '{day} ago {year}',
        '09': '{day} set {year}',
        '10': '{day} ott {year}',
        '11': '{day} nov {year}',
        '12': '{day} dic {year}'
        /* '01': '{day} gennaio {year}',
        '02': '{day} febbraio {year}',
        '03': '{day} marzo {year}',
        '04': '{day} aprile {year}',
        '05': '{day} maggio {year}',
        '06': '{day} giugno {year}',
        '07': '{day} luglio {year}',
        '08': '{day} agosto {year}',
        '09': '{day} settembre {year}',
        '10': '{day} ottobre {year}',
        '11': '{day} novembre {year}',
        '12': '{day} dicembre {year}' */
      },
      hhInizio: 'HH ini',
      mmInizio: 'MM ini',
      hhFine: 'HH fine',
      mmFine: 'MM fine',
      impiegato: 'Dipendenti',
      calend: 'Calendario',
      calendari: {
        calendConge: 'Ferie',
        authCongeVIP: 'VIP'
      },
      dt_creazione: 'Inserito il',
      ggPesati: 'Giorni',
      selectAllApp: 'Seleziona tutti i documenti da Approvare',
      confApp: 'Sei sicuro di voler Approvare tutte le ferie selezionate?',
      noDocsSel: 'Nessun documento selezionato'
    },
    presenze: {
      title: 'Presenze WEB',
      day: 'Giorno',
      hours: 'Ore',
      causal: 'Causale',
      place: 'Località',
      company: 'Azienda',
      officeDepartment: 'Ufficio / Reparto',
      busyness: 'Attività',
      km: 'Km',
      employee: 'Dipendente',
      date: 'Data',
      status: 'Stato',
      attPred: 'ATTIVITA PREDEFINITA',
      detGio: 'Dettaglio Giornaliero: {day}',
      chiuso: '[CHIUSO]',
      aperto: '[ APERTO ]',
      confCloseMonth: 'Sei sicuro di voler Chiudere il Mese?',
      confReg: 'Sei sicuro di voler Registrare le Presenze?',
      info: 'Avviso!',
      confValidation: 'Sei sicuro di voler Convalidare i documenti selezionati?',
      confReopening: 'Sei sicuro di voler Riaprire i documenti selezionati?'
    },
    calendar: {
      title: 'Calendario',
      anno: 'Anno',
      mese: 'Mese',
      vip: 'VIP',
      selectVIP: 'Seleziona VIP',
      impiegato: 'Impiegato',
      calend: 'Calendario',
      modalGiornoTitolo: 'Richiesta di: {nome}',
      note: 'Note',
      V: 'Ferie',
      T: 'Trasferta',
      all: 'Tutti',
      1: 'Do',
      2: 'Lu',
      3: 'Ma',
      4: 'Me',
      5: 'Gi',
      6: 'Ve',
      7: 'Sa',
      mesi: {
        '01': 'Gennaio {year}',
        '02': 'Febbraio {year}',
        '03': 'Marzo {year}',
        '04': 'Aprile {year}',
        '05': 'Maggio {year}',
        '06': 'Giugno {year}',
        '07': 'Luglio {year}',
        '08': 'Agosto {year}',
        '09': 'Settembre {year}',
        '10': 'Ottobre {year}',
        '11': 'Novembre {year}',
        '12': 'Dicembre {year}'
      },
      toApp: 'Da Approvare',
      groups: 'Gruppo/Squadra',
      cecoCoi: 'Centro di Costo COI',
      company: 'Azienda',
      prec: 'Precedente',
      succ: 'Successivo',
      cont: {
        1: {
          0: {
            desc: 'TOT',
            unit: 'gg'
          },
          1: {
            desc: 'GIU',
            unit: 'gg'
          },
          2: {
            desc: 'DIC',
            unit: 'gg'
          }
        },
        2: {
          0: {
            desc: 'CP',
            unit: 'gg'
          },
          1: {
            desc: 'CC',
            unit: 'gg'
          },
          2: {
            desc: 'RC',
            unit: 'hh'
          }
        },
        3: {
          0: {
            desc: 'VAC',
            unit: 'gg'
          },
          1: {
            desc: 'BH',
            unit: 'hh'
          }
        },
        4: {
          0: {
            desc: 'CPL',
            unit: 'gg'
          },
          1: {
            desc: 'CPE',
            unit: 'gg'
          },
          2: {
            desc: 'RHS',
            unit: 'hh'
          },
          3: {
            desc: 'RTT',
            unit: 'hh'
          }
        },
        5: {
          0: {
            desc: 'UR',
            unit: 'gg'
          }
        }
      }
    },
    trasferte: {
      title: 'Trasferta',
      periodo: 'Periodo',
      dataIn: 'Data Inizio',
      dataFin: 'Data Fine',
      partenza: 'Partenza',
      destinazione: 'Destinazione',
      soc: 'Per conto della Società',
      uffRep: 'Ufficio/Reparto',
      referente: 'Persona di Riferimento',
      motivo: 'Motivazione',
      giorno: 'Giorno',
      orario: 'Orario',
      notaResp: 'Nota Responsabile',
      authDiary: 'Vengono visualizzate solo le righe del diario che differiscono dalla destinazione di default',
      respAppDiary: 'Sei sicuro di voler Approvare la riga di Diario?',
      respRejDiary: 'Sei sicuro di voler Rifiutare la riga di Diario?',
      respAppTrip: 'Sei sicuro di voler Approvare la Trasferta',
      respRejTrip: 'Sei sicuro di voler Rifiutare la Trasferta',
      info: 'Avviso!',
      mensa: 'Mensa',
      alloggio: 'Alloggio',
      diario: 'Diario di Viaggio',
      ticket: 'Biglietto',
      trasporti: 'Trasporto',
      auto: 'Vettura Società',
      doc: 'Documenti',
      conformita: {
        titolo: 'Richiesta utilizzo veicolo aziendale',
        testo: 'Per procedere con la richiesta di assegnazione di un veicolo aziendale, il dipendente si impegna ad utilizzarla in conformità alle disposizioni aziendali, fermo restando il rigoroso e coscienzioso rispetto delle norme di circolazione stradale e di ogni precauzione necessaria a preservarne la conservazione e lo stato.<br><br>Inoltre, il dipendente dichiara di possedere una patente di guida:<ul><li>in corso di validità per l\'intero periodo di utilizzo</li><li>non soggetta a provvedimenti di sospensione o revoca</li><li>idonea alla conduzione delle autovetture senza limitazioni di potenza e/o cilindrata</li></ul>',
        abort: 'Operazione Annullata'
      },
      tipoTrasferta: 'Tipologia Trasferta',
      tipoGio: 'Trasferta a Giorni',
      tipoOre: 'Trasferta a Ore',
      numOre: 'Num. Ore',
      to: 'a'
    },
    delSind: {
      anno: 'Anno',
      oreLav: 'Lavorativo',
      oreLavCell: 'Sur TT',
      giorno: 'Giorno',
      oraInizio: 'Ora di inizio',
      to: 'a',
      delegati: 'Delegati',
      delegato: 'Delegato',
      periodo: 'Periodo Richiesto',
      orario: 'Orario',
      numOre: 'Num. Ore',
      nuovaRichiesta: 'Nuova',
      titoloNuovaRichiestaPermesso: 'Nuova richiesta di ferie / Permessi',
      titoloNuovaRichiestaCessione: 'Nuova richiesta di ferie / Permessi',
      tipologia: 'Tipologia',
      tipologie: 'Tipologie',
      dt_creazione: 'Inserito il',
      ifDelete: 'Confermare l\'eliminazione?',
      attenzione: 'Attenzione',
      btn: {
        pdf: 'Compteurs PDF'
      },
      info: 'Avviso!',
      confCessione: 'Sei sicuro di voler inserire la richiesta? Una volta inserita non sarà più possibile modificarla e/o eliminarla',
      residuo: 'Residuo'
    },
    ricAuto: {
      data: 'Data',
      anno: 'Anno',
      mese: 'Mese',
      tipoAuto: 'Tipo Veicolo',
      localita: 'Località',
      orario: 'Orario',
      oreInizio: 'Ora Inizio',
      oreFine: 'Ora Fine',
      puntoRicarica: 'Punto di Ricarica',
      indirizzo: 'Indirizzo',
      connettore: 'Connettore',
      torretta: 'Numero Torretta',
      info: 'Info',
      regole: 'Fasce orarie',
      newTitle: 'Inserimento Prenotazione',
      delTitle: 'Cancellazione Prenotazione',
      delMsg: 'Sei sicuro di voler eliminare questa richiesta?'
    },
    months: {
      '01': 'Gennaio',
      '02': 'Febbraio',
      '03': 'Marzo',
      '04': 'Aprile',
      '05': 'Maggio',
      '06': 'Giugno',
      '07': 'Luglio',
      '08': 'Agosto',
      '09': 'Settembre',
      '10': 'Ottobre',
      '11': 'Novembre',
      '12': 'Dicembre'
    },
    dashboard: {
      // ITALIA
      resFerRip: 'Residuo Fer/Rip',
      resGiugno: 'Residuo Giugno',
      resDicembre: 'Residuo Dicembre',
      // GERMANIA
      resFerAc: 'Urlaub',
      resFerAp: 'Urlaub Alt',
      resZk1: 'Zeitkonto 1',
      resZk2: 'Zeitkonto 2',
      resZk3: 'Zeitkonto 3',
      resZk4: 'Zeitkonto 4',
      // BELGIO
      saldoCPL: 'Solde CPL',
      saldoRTT: 'Solde RTT',
      saldoCPE: 'Solde CPE',
      saldoRHS: 'Saldo RHS',
      d: 'Giorni',
      h: 'Ore',
      perc: '%',
      note_5: 'I giorni/ore richiesti nel portale sono già stati addebitati'
    },
    docs: {
      read: 'Leggi',
      pubblicazione: 'Pubblicato il: ',
      scadenza: 'Scade il:',
      documentType: {
        // ITALIA
        PAIPAGCEDNNU: {
          label: 'Cedolino'
        },
        PAIPAGTIMNNU: {
          label: 'Cartellino'
        },
        PAIPAGLETACN: {
          label: 'Tredicesima'
        },
        PAIPAGLETACC: {
          label: 'Lettera Accompagnatoria'
        },
        PAIPAGMODCUD: {
          label: 'CU'
        },
        // FRANCIA
        PAFPAGCEDNNU: {
          label: 'Cedolino'
        },
        PAFPAGTIMNNU: {
          label: 'Cartellino'
        },
        PAFPAGSITFER: {
          label: 'Situazione Ferie'
        },
        PAFPAGLETGEN: {
          label: 'Lettera Generica'
        },
        PAFPAGLETVAR: {
          label: 'Lettera Personale'
        },
        PAFPAGGIOAZI: {
          label: 'Giornalino Aziendali'
        },
        // SPAGNA
        PAEPAGCEDNNU: {
          label: 'Cedolino'
        },
        RIVPDEDOCPER: {
          label: 'Documento'
        },
        RIVPDELETINF: {
          label: 'Documento Infermeria'
        },
        // BELGIO
        PABPAGTIMNNU: {
          label: 'Cartellino'
        },
        PABPAGCEDNNU: {
          label: 'Cedolino'
        },
        // GERMANIA
        RIGPAGCEDNNU: {
          label: 'Cedolino'
        },
        RIGPAGTIMNNU: {
          label: 'Cartellino'
        }
      },
      btn: {
        annulla: 'Annulla',
        presaVisione: 'Presa Visione',
        leggi: 'Leggi',
        close: 'Chiudi',
        download: 'PDF'
      }
    },
    ...itLocale,
    el: {
      datepicker: {
        now: 'Ora',
        today: 'Oggi',
        cancel: 'Cancella',
        clear: 'Pulisci',
        confirm: 'OK',
        selectDate: 'Seleziona data',
        selectTime: 'Seleziona ora',
        startDate: 'Data inizio',
        startTime: 'Ora inizio',
        endDate: 'Data fine',
        endTime: 'Ora fine',
        prevYear: 'Previous Year', // to be translated
        nextYear: 'Next Year', // to be translated
        prevMonth: 'Previous Month', // to be translated
        nextMonth: 'Next Month', // to be translated
        year: '',
        month1: 'Gennaio',
        month2: 'Febbraio',
        month3: 'Marzo',
        month4: 'Aprile',
        month5: 'Maggio',
        month6: 'Giugno',
        month7: 'Luglio',
        month8: 'Agosto',
        month9: 'Settembre',
        month10: 'Ottobre',
        month11: 'Novembre',
        month12: 'Dicembre',
        // week: 'settimana',
        weeks: {
          sun: 'Dom',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mer',
          thu: 'Gio',
          fri: 'Ven',
          sat: 'Sab'
        },
        months: {
          jan: 'Gennaio',
          feb: 'Febbraio',
          mar: 'Marzo',
          apr: 'Aprile',
          may: 'Maggio',
          jun: 'Giugno',
          jul: 'Luglio',
          aug: 'Agosto',
          sep: 'Settembre',
          oct: 'Ottobre',
          nov: 'Novembre',
          dec: 'Dicembre'
        }
      },
      table: {
        emptyText: 'Nessun dato',
        confirmFilter: 'Conferma',
        resetFilter: 'Reset',
        clearFilter: 'Tutti',
        sumText: 'Sum' // to be translated
      },
      select: {
        loading: 'Caricamento',
        noMatch: 'Nessuna corrispondenza',
        noData: 'Nessun dato',
        placeholder: 'Seleziona'
      }
    }
  },
  fr_FR: {
    questions: {
      q1: 'Nom de jeune fille de la mère',
      q2: 'Nom de jeune fille de la grand-mère maternelle',
      q3: 'Lieu de naissance de la mère',
      q4: 'Nom de l\'animal de compagnie',
      q5: 'Nom de l\'établissement scolaire fréquenté',
      q6: 'Nombre de permis de conduire',
      q7: 'Date mémorable',
      q8: 'Lieu mémorable'
    },
    status: {
      all: 'Tous',
      t: 'Terminé',
      0: 'Sauvé',
      1: 'Envoyé au responsable',
      2: 'Rejeté par le responsable',
      3: 'Approuvé',
      4: 'Envoyé au secrétariat',
      5: 'Rejeté par le secrétariat',
      7: 'Annulé'
    },
    statusDett: {
      0: 'Sauvé',
      1: 'Envoyé',
      2: 'Rejeté', // Rejeté par le responsable',
      3: 'Approuvé', // Approuvé par le secrétariat',
      4: 'Envoyé' // Envoyé au secrétariat'
    },
    msg: {
      noDocFound: 'Aucun Document Trouvé',
      abort: 'Opération annulée'
    },
    placeholder: {
      rangeSeparator: 'au',
      startDate: 'Date du',
      endDate: 'Date au'
    },
    btn: {
      annulla: 'Annule',
      salva: 'Sauvegarder',
      add: 'Ajouter',
      close: 'Fermer',
      copyAuto: 'Copier',
      copy: 'Copier',
      paste: 'Coller',
      confermaApp: 'Confirmez que vous approuvez',
      confermaRej: 'Confirmez que vous refusez',
      approva: 'Approuver',
      rifiuta: 'Refuser',
      nuova: 'Nouvelle',
      conferma: 'Confirmer',
      cerca: 'Rechercher',
      elimina: 'Eliminer',
      sendAll: 'Envoyer tout',
      sendResp: 'Envoyer au responsable',
      sendSecretary: 'Secrétariat',
      seleziona: 'Sélectionner',
      filtri: 'Filtres',
      print: 'Imprimer',
      closeMonth: 'Fermer le mois',
      regPresence: 'Enregistrer',
      defActivity: 'Activité par défaut',
      riapri: 'Reouvrir',
      convalida: 'Validation',
      addActivity: 'Ajouter une activité',
      svuotaCampi: 'Champs vides',
      yes: 'Oui',
      no: 'Non',
      legenda: 'Légende'
    },
    country: {
      label: 'pays',
      1: 'Italie',
      2: 'France',
      3: 'Espagne',
      4: 'Belgique',
      5: 'Allemagne',
      L: 'Lussemburgo'
    },
    filtri: {
      selFiltri: 'Filtres',
      mandatory: 'Champs obligatoires',
      selkeyword: 'Veuillez saisir un mot clé'
    },
    ferie: {
      titolo: 'Suivi des demandes',
      titoloAuth: 'Autoriser/Refuser',
      titoloCalend: 'Calendrier congé',
      it_resTt: 'Solde',
      it_resGiugno: 'Solde Juin',
      it_resDicembre: 'Solde Déc',
      fr_resCpNap: 'CP année préc.',
      fr_resCpN: 'CP année cours',
      fr_resRcr: 'RCR',
      fr_resRce: 'RCE',
      es_resVac: 'Vacaciones restantes',
      es_resVacAA: 'Vacaciones año anterior',
      es_resVacAC: 'Vacaciones del año',
      es_resBH: 'BH',
      es_resVac_mobile: 'VAC',
      es_resVacAA_mobile: 'VAC AA',
      es_resVacAC_mobile: 'VAC AC',
      es_resBH_mobile: 'B.H.',
      be_resCpl: 'Conge Legaux JJ',
      be_resCpe: 'Conge Extralegaux JJ',
      be_resRtt: 'RTT HH',
      be_resRhs: 'RHS HH',
      be_resCpl_mobile: 'CPL',
      be_resCpe_mobile: 'CPE',
      be_resRtt_mobile: 'RTT',
      be_resRhs_mobile: 'RHS',
      de_resAc: 'Urlaub',
      de_resAp: 'Urlaub Alt',
      de_resRh1: 'Zeitkonto 1',
      de_resRh2: 'Zeitkonto 2',
      de_resRh3: 'Zeitkonto 3',
      de_resRh4: 'Zeitkonto 4',
      resAc: 'UR',
      resAp: 'UA',
      resRh1: 'Z1',
      resRh2: 'Z2',
      resRh3: 'Z3',
      resRh4: 'Z4',
      tipo: 'Type',
      dal: 'Du',
      al: 'Au',
      to: 'a',
      dataTo: 'au',
      numOre: 'N. Heures',
      oreDa: 'Debut',
      oreA: 'Fin',
      periodo: 'Période d\'absence',
      orario: 'Debut - Fin',
      stato: 'Status',
      note: 'Notes',
      dip: 'Notes Emp.',
      resp: 'Notes Resp.',
      noteDip: 'Employé notes',
      noteResp: 'Responsable notes',
      ifDelete: 'Confirmer élimination?',
      attenzione: 'Attention',
      nuovaRichiesta: 'Nouvelle',
      titoloNuovaRichiesta: 'Nouvelle demande de congé',
      tipologia: 'Typologie',
      dataDa: 'Date du',
      dataDa_placeholder: 'Date du',
      dataA: 'au',
      oraInizio: 'Heure debut',
      oraFine: 'fin',
      conferma: 'Confirmer',
      ifInviaRichiesta: 'Je fractionne mon congé principale pour raison personnelle et je renonce donc aux congés de fractionnement inhérents.',
      si: 'Oui',
      no: 'Non',
      anno: 'Année',
      mese: 'Mois',
      vip: 'Vip',
      status: {
        A: 'Envoyé',
        C: 'Approuvé',
        R: 'Rejeté',
        T: 'Tous',
        T_des: 'Tous',
        C_des: 'Demande autorisée',
        A_des: 'Demande à autoriser',
        R_des: 'Demande refuser'
      },
      noData: 'Aucun document trouvé',
      errorNoPeriodo: 'Saisir la periode du conge',
      autorizzare: 'Confirmer Autoriser?',
      rifiutare: 'Confirmer Refuser?',
      d: 'Jours',
      h: 'Heures',
      mesi: {
        '01': '{day} janvier {year}',
        '02': '{day} février  {year}',
        '03': '{day} mars {year}',
        '04': '{day} avril {year}',
        '05': '{day} mai {year}',
        '06': '{day} juin {year}',
        '07': '{day} juillet {year}',
        '08': '{day} août {year}',
        '09': '{day} septembre {year}',
        '10': '{day} octobre {year}',
        '11': '{day} novembre {year}',
        '12': '{day} décembre {year}'
      },
      hhInizio: 'HH deb',
      mmInizio: 'MM deb',
      hhFine: 'HH fin',
      mmFine: 'MM fin',
      impiegato: 'Employès',
      calend: 'Calendrier',
      calendari: {
        calendConge: 'Congé',
        authCongeVIP: 'VIP'
      },
      dt_creazione: 'Date Demande',
      ggPesati: 'Jours',
      selectAllApp: 'Sélectionner tous les documents à annuler',
      confApp: 'Êtes-vous sur d\'approuver toutes les demandes de absences selectionnées?',
      noDocsSel: 'Aucun document selectionné'
    },
    presenze: {
      title: 'WEB Présence',
      day: 'Jour',
      hours: 'Heures',
      causal: 'Présence/Absence',
      place: 'Lieu de travail',
      company: 'Société',
      officeDepartment: 'Bureau/département',
      busyness: 'Activité',
      km: 'Km',
      employee: 'Salarié',
      date: 'Date',
      status: 'Etat',
      attPred: 'Activité par défaut',
      detGio: 'Détail du jour: {day}',
      chiuso: '[FERMÉ]',
      aperto: '[OUVERT]',
      confCloseMonth: 'Êtes-vous sur de vouloir fermer le mois?',
      confReg: 'Êtes-vous sur de vouloir enregistrer les presences?',
      info: 'Info!',
      confValidation: 'Êtes-vous sur de vouloir valider les documents selectionnées?',
      confReopening: 'Êtes-vous sur de vouloir reouvrir les documents selectionnées?'
    },
    calendar: {
      title: 'Calendrier',
      anno: 'Année',
      mese: 'Mois',
      vip: 'VIP',
      selectVIP: 'Sélectionner VIP',
      impiegato: 'Employes',
      calend: 'Calendrier',
      modalGiornoTitolo: 'Demande: {nome}',
      note: 'Note',
      V: 'Congé',
      T: 'Deplacement',
      all: 'Tous',
      1: 'Di',
      2: 'Lu',
      3: 'Ma',
      4: 'Me',
      5: 'Je',
      6: 'Ve',
      7: 'Sa',
      mesi: {
        '01': 'Janvier {year}',
        '02': 'Février {year}',
        '03': 'Mars {year}',
        '04': 'Avril {year}',
        '05': 'Mai {year}',
        '06': 'Juin {year}',
        '07': 'Juillet {year}',
        '08': 'Août {year}',
        '09': 'Septembre {year}',
        '10': 'Octobre {year}',
        '11': 'Novembre {year}',
        '12': 'Décembre {year}'
      },
      toApp: 'Doit être approuvé',
      groups: 'Groupe/Équipe',
      cecoCoi: 'Centre de coûts COI',
      company: 'Société',
      prec: 'Précédent',
      succ: 'Suivant',
      cont: {
        1: {
          0: {
            desc: 'TOT',
            unit: 'jour'
          },
          1: {
            desc: 'JUIN',
            unit: 'day'
          },
          2: {
            desc: 'DÉC',
            unit: 'day'
          }
        },
        2: {
          0: {
            desc: 'CP',
            unit: 'jour'
          },
          1: {
            desc: 'CC',
            unit: 'jour'
          },
          2: {
            desc: 'RC',
            unit: 'hh'
          }
        },
        3: {
          0: {
            desc: 'VAC',
            unit: 'jour'
          },
          1: {
            desc: 'BH',
            unit: 'hh'
          }
        },
        4: {
          0: {
            desc: 'CPL',
            unit: 'jour'
          },
          1: {
            desc: 'CPE',
            unit: 'jour'
          },
          2: {
            desc: 'RHS',
            unit: 'hh'
          },
          3: {
            desc: 'RTT',
            unit: 'hh'
          }
        },
        5: {
          0: {
            desc: 'UR',
            unit: 'jour'
          }
        }
      }
    },
    trasferte: {
      title: 'Deplacement',
      periodo: 'Date du-au',
      dataIn: 'Date du',
      dataFin: 'Date au',
      partenza: 'Départ',
      destinazione: 'Destination',
      soc: 'pour le compte de',
      referente: 'Personne de référence',
      uffRep: 'Bureau/département',
      motivo: 'Motif',
      giorno: 'Jour',
      orario: 'Horaire',
      notaResp: 'Responsable notes',
      authDiary: 'Sont visualisées seulement les lignes du journal de voyage que different de la destination de default.',
      respAppDiary: 'Êtes-vous sur d\'approuver la ligne du jurnal de voyage?',
      respRejDiary: 'Êtes-vous sur de refuser la ligne du jurnal de voyage?',
      respAppTrip: 'Êtes-vous sur d\'approuver le déplacement?',
      respRejTrip: 'Êtes-vous sur de refuser le déplacement?',
      info: 'Info!',
      mensa: 'Repas',
      alloggio: 'Hébergement',
      diario: 'Détail du voyage',
      ticket: 'Réserver Billets Voyage',
      trasporti: 'Transports',
      auto: 'Voiture',
      doc: 'Documents',
      conformita: {
        titolo: 'Demande d\'utilisation du véhicule de l\'entreprise',
        testo: 'Pour procéder à la demande d\'attribution d\'un véhicule de société, le salarié s\'engage à l\'utiliser conformément aux dispositions de l\'entreprise, tout en respectant scrupuleusement et consciencieusement les règles du code de la route ainsi que toutes les précautions nécessaires à sa conservation et à son bon état.<br><br>En outre, le salarié déclare être titulaire d\'un permis de conduire :<ul><li>valide pendant toute la durée d\'utilisation</li><li>non soumis à des mesures de suspension ou de retrait</li><li>approprié à la conduite de véhicules sans limitation de puissance et/ou de cylindrée</li></ul>',
        abort: 'Opération annulée'
      },
      tipoTrasferta: 'Type de déplacement',
      tipoGio: 'Déplacement - jours',
      tipoOre: 'Déplacement - heures',
      numOre: 'N. Heures',
      to: 'a'
    },
    delSind: {
      anno: 'Année',
      oreLav: 'Hors temps de travail',
      oreLavCell: 'Sur TT',
      giorno: 'Jour',
      oraInizio: 'Heure debut',
      to: 'a',
      delegati: 'Délégués',
      delegato: 'Déléguer',
      periodo: 'Date du-au',
      orario: 'Horaire',
      numOre: 'N. Heures',
      nuovaRichiesta: 'Nouvelle',
      titoloNuovaRichiestaPermesso: 'Nouvelle demande',
      titoloNuovaRichiestaCessione: 'Nouvelle demande de cession des heures',
      tipologia: 'Typologie',
      tipologie: 'Typologies',
      dt_creazione: 'Date Demande',
      ifDelete: 'Confirmer élimination?',
      attenzione: 'Attention',
      btn: {
        pdf: 'Compteurs PDF'
      },
      info: 'Info!',
      confCessione: 'Etes-vous sûr de vouloir procéder à la demande ? Une fois saisie, il ne sera plus possible de la modifier ou de la supprimer.',
      residuo: 'Solde'
    },
    ricAuto: {
      data: 'Date',
      anno: 'Année',
      mese: 'Mois',
      tipoAuto: 'Type de Véhicule',
      localita: 'Localité',
      orario: 'Horaire',
      oreInizio: 'Heure de Début',
      oreFine: 'Heure de Fin',
      puntoRicarica: 'Point de Recharge',
      indirizzo: 'Adresse',
      connettore: 'Connecteur',
      torretta: 'Numéro de Colonne',
      info: 'Infos',
      regole: 'Plages Horaires',
      newTitle: 'Ajout de Réservation',
      delTitle: 'Annulation de la réservation',
      delMsg: 'Êtes-vous sûr de vouloir supprimer cette demande ?'
    },
    months: {
      '01': 'Janvier',
      '02': 'Février',
      '03': 'Mars',
      '04': 'Avril',
      '05': 'Mai',
      '06': 'Juin',
      '07': 'Juillet',
      '08': 'Août',
      '09': 'Septembre',
      '10': 'Octobre',
      '11': 'Novembre',
      '12': 'Décembre'
    },
    dashboard: {
      // ITALIA
      resFerRip: 'Residuo Fer/Rip',
      resGiugno: 'Residuo Giugno',
      resDicembre: 'Residuo Dicembre',
      // GERMANIA
      resFerAc: 'Urlaub',
      resFerAp: 'Urlaub Alt',
      resZk1: 'Zeitkonto 1',
      resZk2: 'Zeitkonto 2',
      resZk3: 'Zeitkonto 3',
      resZk4: 'Zeitkonto 4',
      // BELGIO
      saldoCPL: 'Solde CPL',
      saldoRTT: 'Solde RTT',
      saldoCPE: 'Solde CPE',
      saldoRHS: 'Saldo RHS',
      d: 'Jours',
      h: 'Heure',
      perc: '%',
      note_5: 'Les jours/heures demandés dans le portail sont inclus'
    },
    docs: {
      read: 'Lois',
      pubblicazione: 'Pubblicato il: ',
      scadenza: 'Scade il:',
      documentType: {
        // ITALIA
        PAIPAGCEDNNU: {
          label: 'Bulletins de paie'
        },
        PAIPAGTIMNNU: {
          label: 'Feuille de pointage'
        },
        PAIPAGLETACN: {
          label: 'Treizième mensualité'
        },
        PAIPAGLETACC: {
          label: 'Lettera Accompagnatoria'
        },
        PAIPAGMODCUD: {
          label: 'CU'
        },
        // FRANCIA
        PAFPAGCEDNNU: {
          label: 'Bulletins de paie'
        },
        PAFPAGTIMNNU: {
          label: 'Feuille de pointage'
        },
        PAFPAGSITFER: {
          label: 'Situation de vacances'
        },
        PAFPAGLETGEN: {
          label: 'Lettres génériques'
        },
        PAFPAGLETVAR: {
          label: 'Lettres personnelles'
        },
        PAFPAGGIOAZI: {
          label: 'Journal entreprise'
        },
        // SPAGNA
        PAEPAGCEDNNU: {
          label: 'Bulletins de paie'
        },
        RIVPDEDOCPER: {
          label: 'Document'
        },
        RIVPDELETINF: {
          label: 'Document d\'infirmerie'
        },
        // BELGIO
        PABPAGTIMNNU: {
          label: 'Feuille de pointage'
        },
        PABPAGCEDNNU: {
          label: 'Bulletins de paie'
        },
        // GERMANIA
        RIGPAGCEDNNU: {
          label: 'Bulletins de paie'
        },
        RIGPAGTIMNNU: {
          label: 'Feuille de pointage'
        }
      },
      btn: {
        annulla: 'Annule',
        presaVisione: 'Presa Visione',
        leggi: 'Lire',
        close: 'Fermer',
        download: 'PDF'
      }
    },
    ...frLocale
  },
  es_ES: {
    questions: {
      q1: 'Apellido de soltera de la madre',
      q2: 'Apellido de soltera de la abuela materna',
      q3: 'País de nacimiento de la madre',
      q4: 'Nombre de mascota',
      q5: 'Nombre del colegio frecuentado',
      q6: 'Número de carnet de conducir',
      q7: 'Fecha memorable',
      q8: 'Lugar memorable'
    },
    status: {
      all: 'Todos',
      t: 'Terminado',
      0: 'Sauvé',
      1: 'Envoyé au responsable',
      2: 'Rejeté par le responsable',
      3: 'Approuvé',
      4: 'Envoyé au secrétariat',
      5: 'Rejeté par le secrétariat',
      7: 'Annulé'
    },
    statusDett: {
      0: 'Guardado',
      1: 'Enviar',
      2: 'Rechazado', // Rejeté par le responsable',
      3: 'Aprobado', // Approuvé par le secrétariat',
      4: 'Enviar' // Envoyé au secrétariat'
    },
    msg: {
      noDocFound: 'Ningún documento disponible',
      abort: 'Operación cancelada'
    },
    placeholder: {
      rangeSeparator: 'a',
      startDate: 'Fecha desde',
      endDate: 'Fecha hasta'
    },
    btn: {
      annulla: 'Anular',
      salva: 'Guardar',
      add: 'aAñadir',
      close: 'Cierra',
      copyAuto: 'Copia',
      copy: 'Copia',
      paste: 'Pegar',
      confermaApp: 'Confirmar aprobación',
      confermaRej: 'Confirmar rechazo',
      approva: 'Aprobado',
      rifiuta: 'Rechazado',
      nuova: 'Nuevo',
      conferma: 'Confirmar',
      cerca: 'Buscar',
      elimina: 'Eliminar',
      sendAll: 'Enviar todo',
      sendResp: 'Enviar al Responsable',
      sendSecretary: 'Secretaria',
      seleziona: 'Seleccionar',
      filtri: 'Filtros',
      print: 'Imprenta',
      closeMonth: 'Cerrar el mes',
      regPresence: 'Registrar',
      defActivity: 'Actividad predefinida',
      riapri: 'Reabrir',
      convalida: 'Validación',
      addActivity: 'Agregar actividades',
      svuotaCampi: 'Eliminar campos',
      yes: 'Si',
      no: 'No',
      legenda: 'Leyenda'
    },
    country: {
      label: 'Naciones',
      1: 'Italia',
      2: 'Francia',
      3: 'España',
      4: 'Bélgica',
      5: 'Alemania',
      L: 'Lussemburgo'
    },
    filtri: {
      selFiltri: 'Filtros',
      mandatory: 'Campos obligatorios',
      selkeyword: 'Por favor, introduzca una palabra clave'
    },
    ferie: {
      titolo: 'Resumen de ausencia',
      titoloAuth: 'Aprobar ausencia',
      titoloCalend: 'Calendario de ausencia',
      it_resTt: 'Saldo',
      it_resGiugno: 'Saldo Junio',
      it_resDicembre: 'Saldo Dic',
      fr_resCpNap: 'CP année préc.',
      fr_resCpN: 'CP année cours',
      fr_resRcr: 'RCR',
      fr_resRce: 'RCE',
      es_resVac: 'Vacaciones restantes',
      es_resVacAA: 'Vacaciones año anterior',
      es_resVacAC: 'Vacaciones del año',
      es_resBH: 'Banca horas',
      es_resVac_mobile: 'VAC',
      es_resVacAA_mobile: 'VAC AA',
      es_resVacAC_mobile: 'VAC AC',
      es_resBH_mobile: 'B.H.',
      be_resCpl: 'Conge Legaux JJ',
      be_resCpe: 'Conge Extralegaux JJ',
      be_resRtt: 'RTT HH',
      be_resRhs: 'RHS HH',
      be_resCpl_mobile: 'CPL',
      be_resCpe_mobile: 'CPE',
      be_resRtt_mobile: 'RTT',
      be_resRhs_mobile: 'RHS',
      de_resAc: 'Urlaub',
      de_resAp: 'Urlaub Alt',
      de_resRh1: 'Zeitkonto 1',
      de_resRh2: 'Zeitkonto 2',
      de_resRh3: 'Zeitkonto 3',
      de_resRh4: 'Zeitkonto 4',
      resAc: 'UR',
      resAp: 'UA',
      resRh1: 'Z1',
      resRh2: 'Z2',
      resRh3: 'Z3',
      resRh4: 'Z4',
      tipo: 'Tipología',
      dal: 'Desde',
      al: 'Hasta',
      to: 'a',
      dataTo: 'a',
      numOre: 'N. Horas',
      oreDa: 'Inicio',
      oreA: 'Fin',
      periodo: 'Período de ausencia',
      orario: 'Inicio - Fin',
      stato: 'Estado',
      note: 'Notes',
      dip: 'Notas Emp.',
      resp: 'Notas Resp.',
      noteDip: 'Notas de los empleados',
      noteResp: 'Notas de responsable',
      ifDelete: '¿Confirmar eliminación?',
      attenzione: 'Atención',
      nuovaRichiesta: 'Nueva',
      titoloNuovaRichiesta: 'Nueva solicitud de ausencia',
      tipologia: 'Tipología',
      dataDa: 'Fecha desde',
      dataDa_placeholder: 'Fecha desde',
      dataA: 'Hasta',
      oraInizio: 'Hora de inicio',
      oraFine: 'Fin',
      conferma: 'Confirmar',
      ifInviaRichiesta: 'Je fractionne mon congé principale pour raison personnelle et je renonce donc aux congés de fractionnement inhérents.',
      si: 'Si',
      no: 'No',
      anno: 'Año',
      mese: 'Mes',
      vip: 'Vip',
      status: {
        A: 'Enviado',
        C: 'Aprobado',
        R: 'Rechazado',
        T: 'Todo',
        T_des: 'Todos',
        C_des: 'Solicitud autorizada',
        A_des: 'Solicitud de autorización',
        R_des: 'Solicitud de rechazo'
      },
      noData: 'No se encontraron documentos',
      errorNoPeriodo: 'Ingrese el período de ausencia',
      autorizzare: 'Confirmar Permitir?',
      rifiutare: 'Confirmar Rechazar?',
      d: 'Días',
      h: 'Horas',
      mesi: {
        '01': '{day} enero {year}',
        '02': '{day} febrero {year}',
        '03': '{day} marzo {year}',
        '04': '{day} abril {year}',
        '05': '{day} mayo {year}',
        '06': '{day} junio {year}',
        '07': '{day} julio {year}',
        '08': '{day} agosto {year}',
        '09': '{day} septiembre {year}',
        '10': '{day} octubre {year}',
        '11': '{day} noviembre {year}',
        '12': '{day} diciembre {year}'
      },
      hhInizio: 'HH ini',
      mmInizio: 'MM ini',
      hhFine: 'HH fin',
      mmFine: 'MM fin',
      impiegato: 'Employès',
      calend: 'Calendario',
      calendari: {
        calendConge: 'Vacaciones',
        authCongeVIP: 'VIP'
      },
      dt_creazione: 'Fecha solicitada',
      ggPesati: 'Días',
      selectAllApp: 'Seleccionar todos los documentos pendientes de aprobación',
      confApp: '¿Seguro que quieres aprobar todos los ausencia seleccionados?',
      noDocsSel: 'Ningún documento seleccionado'
    },
    presenze: {
      title: 'WEB Presencias',
      day: 'Día',
      hours: 'Horas',
      causal: 'Motivo',
      place: 'Localización',
      company: 'Sociedad',
      officeDepartment: 'Oficina/Departamento',
      busyness: 'Actividad',
      km: 'Km',
      employee: 'Empleado',
      date: 'Fecha',
      status: 'País',
      attPred: 'Actividad predefinida',
      detGio: 'Detalle del día: {day}',
      chiuso: '[CERRADO]',
      aperto: '[ABIERTO]',
      confCloseMonth: '¿Estás seguro de querer cerrar el mes?',
      confReg: '¿Estás seguro de querer registrar las presencias?',
      info: '¡Aviso!',
      confValidation: '¿Está seguro de querer validar los documentos seleccionados?',
      confReopening: '¿Está seguro de querer reabrir los documentos seleccionados?'
    },
    calendar: {
      title: 'Calendario',
      anno: 'Año',
      mese: 'Mes',
      vip: 'VIP',
      selectVIP: 'Seleccionar VIP',
      impiegato: 'Empleados',
      calend: 'Calendario',
      modalGiornoTitolo: 'Pedido: {nome}',
      note: 'Nota',
      V: 'Vacaciones',
      T: 'Viaje',
      all: 'Todos',
      1: 'Do',
      2: 'Lu',
      3: 'Ma',
      4: 'Mi',
      5: 'Ju',
      6: 'Vi',
      7: 'Sa',
      mesi: {
        '01': 'Enero {year}',
        '02': 'Febrero {year}',
        '03': 'Marzo {year}',
        '04': 'Abril {year}',
        '05': 'Mayo {year}',
        '06': 'Junio {year}',
        '07': 'Julio {year}',
        '08': 'Agosto {year}',
        '09': 'Septiembre {year}',
        '10': 'Octubre {year}',
        '11': 'Noviembre {year}',
        '12': 'Diciembre {year}'
      },
      toApp: 'Para ser aprobado',
      groups: 'Grupo/Equipo',
      cecoCoi: 'Centro de costos COI',
      company: 'Sociedad',
      prec: 'Anterior',
      succ: 'Siguiente',
      cont: {
        1: {
          0: {
            desc: 'TOT',
            unit: 'dia'
          },
          1: {
            desc: 'JUN',
            unit: 'day'
          },
          2: {
            desc: 'DIC',
            unit: 'day'
          }
        },
        2: {
          0: {
            desc: 'CP',
            unit: 'dia'
          },
          1: {
            desc: 'CC',
            unit: 'dia'
          },
          2: {
            desc: 'RC',
            unit: 'hh'
          }
        },
        3: {
          0: {
            desc: 'VAC',
            unit: 'dia'
          },
          1: {
            desc: 'BH',
            unit: 'hh'
          }
        },
        4: {
          0: {
            desc: 'CPL',
            unit: 'dia'
          },
          1: {
            desc: 'CPE',
            unit: 'dia'
          },
          2: {
            desc: 'RHS',
            unit: 'hh'
          },
          3: {
            desc: 'RTT',
            unit: 'hh'
          }
        },
        5: {
          0: {
            desc: 'UR',
            unit: 'dia'
          }
        }
      }
    },
    trasferte: {
      periodo: 'Fecha desde-hasta',
      dataIn: 'Dia salida',
      dataFin: 'Dia regreso',
      partenza: 'Salida',
      destinazione: 'Destino',
      soc: 'Por cuenta de la sociedad',
      referente: 'Persona de referencia',
      uffRep: 'Oficina/Empresa',
      motivo: 'Referencia',
      giorno: 'Día',
      orario: 'Horas',
      notaResp: 'Nota Responsables',
      authDiary: 'Solo se muestran las líneas del registro de viaje que son diferentes del destino predeterminado.',
      respAppDiary: '¿Está seguro que quiere aprobar la linea de la agenda?',
      respRejDiary: '¿Está seguro que quiere rechazar la linea de la agenda?',
      respAppTrip: '¿Está seguro de que desea aprobar la solicitud de viaje?',
      respRejTrip: '¿Está seguro que quiere rechazar la solicitud de viaje?',
      info: '¡Aviso!',
      mensa: 'Comedor',
      alloggio: 'Alojamiento',
      diario: 'Agenda de viaje',
      ticket: 'Ticket',
      trasporti: 'Transporte',
      auto: 'Coche',
      doc: 'Documentos',
      conformita: {
        titolo: 'Solicitud de uso del vehículo de la empresa',
        testo: 'Para poder proceder con la solicitud de asignación de un coche de empresa, el empleado se compromete a utilizarlo conforme a las normativas internas de la empresa, sin perjuicio del cumplimiento riguroso y escrupuloso de las normas de tráfico y de cualquier precaución necesaria para preservar su conservación y estado.<br><br>Asimismo, el empleado declara estar en posesión de un permiso de conducir:<ul><li>válido durante todo el periodo de uso</li><li>no sujeto a medidas de suspensión o revocación</li><li>apto para conducir automóviles sin limitaciones de potencia y/o cilindrada</li></ul>',
        abort: 'Operación cancelada'
      },
      tipoTrasferta: 'Tipo de viaje',
      tipoGio: 'Viaje - días',
      tipoOre: 'Viaje - horas',
      numOre: 'N. Horas',
      to: 'a'
    },
    delSind: {
      anno: 'Année',
      oreLav: 'Hors temps de travail',
      oreLavCell: 'Sur TT',
      giorno: 'Jour',
      oraInizio: 'Heure debut',
      to: 'a',
      delegati: 'Délégués',
      delegato: 'Déléguer',
      periodo: 'Date du-au',
      orario: 'Horaire',
      numOre: 'N. Heures',
      nuovaRichiesta: 'Nouvelle',
      titoloNuovaRichiestaPermesso: 'Nouvelle demande',
      titoloNuovaRichiestaCessione: 'Nouvelle demande de cession des heures',
      tipologia: 'Typologie',
      tipologie: 'Typologies',
      dt_creazione: 'Date Demande',
      ifDelete: 'Confirmer élimination?',
      attenzione: 'Attention',
      btn: {
        pdf: 'Compteurs PDF'
      },
      info: '¡Aviso!',
      confCessione: 'Sei sicuro di voler inserire la richiesta? Una volta inserita non sarà più possibile modificarla e/o eliminarla',
      residuo: 'Residuo'
    },
    ricAuto: {
      data: 'Fecha',
      anno: 'Año',
      mese: 'Mes',
      tipoAuto: 'Tipo de Vehículo',
      localita: 'Localidad',
      orario: 'Horario',
      oreInizio: 'Hora de Inicio',
      oreFine: 'Hora de Fin',
      puntoRicarica: 'Punto de Carga',
      indirizzo: 'Dirección',
      connettore: 'Conector',
      torretta: 'Número de Poste',
      info: 'Información',
      regole: 'Franjas Horarias',
      newTitle: 'Añadir Reserva',
      delTitle: 'Cancelación de la reserva',
      delMsg: '¿Está seguro de que desea eliminar esta solicitud?'
    },
    months: {
      '01': 'Enero',
      '02': 'Febrero',
      '03': 'Marzo',
      '04': 'Abril',
      '05': 'Mayo',
      '06': 'Junio',
      '07': 'Julio',
      '08': 'Agosto',
      '09': 'Septiembre',
      '10': 'Octubre',
      '11': 'Noviembre',
      '12': 'Diciembre'
    },
    dashboard: {
      // ITALIA
      resFerRip: 'Residuo Fer/Rip',
      resGiugno: 'Residuo Giugno',
      resDicembre: 'Residuo Dicembre',
      // GERMANIA
      resFerAc: 'Urlaub',
      resFerAp: 'Urlaub Alt',
      resZk1: 'Zeitkonto 1',
      resZk2: 'Zeitkonto 2',
      resZk3: 'Zeitkonto 3',
      resZk4: 'Zeitkonto 4',
      // BELGIO
      saldoCPL: 'Solde CPL',
      saldoRTT: 'Solde RTT',
      saldoCPE: 'Solde CPE',
      saldoRHS: 'Saldo RHS',
      d: 'Dias',
      h: 'Horas',
      perc: '%',
      note_5: 'Ya se cobraron los días/horas solicitados en el portal'
    },
    docs: {
      read: 'Leyes',
      pubblicazione: 'Publicado el : ',
      scadenza: 'Caduca el:',
      documentType: {
        // ITALIA
        PAIPAGCEDNNU: {
          label: 'Hoja de salario'
        },
        PAIPAGTIMNNU: {
          label: 'Hoja de puntuacion'
        },
        PAIPAGLETACN: {
          label: 'Decimotercera mensualidad'
        },
        PAIPAGLETACC: {
          label: 'Lettera Accompagnatoria'
        },
        PAIPAGMODCUD: {
          label: 'CU'
        },
        // FRANCIA
        PAFPAGCEDNNU: {
          label: 'Hoja de salario'
        },
        PAFPAGTIMNNU: {
          label: 'Hoja de puntuacion'
        },
        PAFPAGSITFER: {
          label: 'Situación de vacaciones'
        },
        PAFPAGLETGEN: {
          label: 'Lettres génériques'
        },
        PAFPAGLETVAR: {
          label: 'Lettres personnelles'
        },
        PAFPAGGIOAZI: {
          label: 'Periódico de la empresa'
        },
        // SPAGNA
        PAEPAGCEDNNU: {
          label: 'Hoja de salario'
        },
        RIVPDEDOCPER: {
          label: 'Documentos'
        },
        RIVPDELETINF: {
          label: 'Vigilancia de la Salud'
        },
        // GERMANIA
        RIGPAGCEDNNU: {
          label: 'Hoja de salario'
        },
        RIGPAGTIMNNU: {
          label: 'Hoja de puntuacion'
        },
        // BELGIO
        PABPAGTIMNNU: {
          label: 'Hoja de puntuacion'
        },
        PABPAGCEDNNU: {
          label: 'Hoja de salario'
        }
      },
      btn: {
        annulla: 'Anular',
        presaVisione: 'Presa Visione',
        leggi: 'Leer',
        close: 'Cierra',
        download: 'PDF'
      }
    },
    ...esLocale
  },
  de_DE: {
    questions: {
      q1: 'Mädchenname der Mutter',
      q2: 'Mädchenname der Großmutter',
      q3: 'Geburtsland der Mutter',
      q4: 'Name des Haustieres',
      q5: 'Name der Schule',
      q6: 'Führerscheinnummer',
      q7: 'Wichtiges Datum',
      q8: 'Wichtiger Ort'
    },
    status: {
      all: 'Alles',
      t: 'Fertig',
      0: 'Gespeichert',
      1: 'An den Beauftragten senden',
      2: 'Rurch den Beauftragten abgelehnt',
      3: 'Angenommen',
      4: 'An das Sekretariat senden',
      5: 'Durch das Sekretariat abgelehnt',
      7: 'Abgebrochen'
    },
    statusDett: {
      0: 'Gespeichert',
      1: 'Geschickt',
      2: 'Abgelehnt', // Rejeté par le responsable',
      3: 'Genehmigt', // Approuvé par le secrétariat',
      4: 'Geschickt' // Envoyé au secrétariat'
    },
    msg: {
      noDocFound: 'Kein Dokument gefunden',
      abort: 'Auftrag wurde abgebrochen'
    },
    placeholder: {
      rangeSeparator: 'bis',
      startDate: 'Beginn',
      endDate: 'Ende'
    },
    btn: {
      annulla: 'Abbrechen',
      salva: 'Speichern',
      add: 'Hinzufügen',
      close: 'Schließen',
      copyAuto: 'Kopieren',
      copy: 'Kopieren',
      paste: 'Einfügen',
      confermaApp: 'Bestätigungsgenehmigung',
      confermaRej: 'Ablehnung bestätigen',
      approva: 'Angenommen',
      rifiuta: 'Abgelehnt',
      nuova: 'Neu',
      conferma: 'Bestätigung',
      cerca: 'Suchen',
      elimina: 'löschen',
      sendAll: 'Alles abschicken',
      sendResp: 'an den Beauftragten senden',
      sendSecretary: 'Sekretariat',
      seleziona: 'Wählen',
      filtri: 'Filter',
      print: 'Drucken',
      closeMonth: 'Schließen',
      regPresence: 'Aufzeichnung',
      defActivity: 'Haupttätigkeit',
      riapri: 'Wiederöffnen',
      convalida: 'Bestätigung',
      addActivity: 'Aktivitäten hinzufügen',
      svuotaCampi: 'Felder löschen',
      yes: 'Ja',
      no: 'Nein',
      legenda: 'Legende'
    },
    country: {
      label: 'Nationen',
      1: 'Italien',
      2: 'Frankreich',
      3: 'Spanien',
      4: 'Belgien',
      5: 'Deutschland',
      L: 'Lussemburgo'
    },
    filtri: {
      selFiltri: 'Filter',
      mandatory: 'Pflichtfelder',
      selkeyword: 'Bitte geben Sie ein Schlüsselwort ein'
    },
    ferie: {
      titolo: 'Antrag stellen',
      titoloAuth: 'Antrag Autorisieren',
      titoloCalend: 'Kalender',
      it_resTt: 'Verfügbares',
      it_resGiugno: 'Jun-Verfügbares',
      it_resDicembre: 'Dez-Verfügbares',
      fr_resCpNap: 'CP année préc.',
      fr_resCpN: 'CP année cours',
      fr_resRcr: 'RCR',
      fr_resRce: 'RCE',
      es_resVac: 'Vacaciones restantes',
      es_resVacAA: 'Vacaciones año anterior',
      es_resVacAC: 'Vacaciones del año',
      es_resBH: 'Zeitkonto',
      es_resVac_mobile: 'VAC',
      es_resVacAA_mobile: 'VAC AA',
      es_resVacAC_mobile: 'VAC AC',
      es_resBH_mobile: 'B.H.',
      be_resCpl: 'Conge Legaux JJ',
      be_resCpe: 'Conge Extralegaux JJ',
      be_resRtt: 'RTT HH',
      be_resRhs: 'RHS HH',
      be_resCpl_mobile: 'CPL',
      be_resCpe_mobile: 'CPE',
      be_resRtt_mobile: 'RTT',
      be_resRhs_mobile: 'RHS',
      de_resAc: 'Urlaub',
      de_resAp: 'Urlaub Alt',
      de_resRh1: 'Zeitkonto 1',
      de_resRh2: 'Zeitkonto 2',
      de_resRh3: 'Zeitkonto 3',
      de_resRh4: 'Zeitkonto 4',
      resAc: 'UR',
      resAp: 'UA',
      resRh1: 'Z1',
      resRh2: 'Z2',
      resRh3: 'Z3',
      resRh4: 'Z4',
      tipo: 'Art',
      dal: 'Von',
      al: 'Bis',
      to: 'bis',
      dataTo: 'bis',
      numOre: 'Anzahl Stunden',
      oreDa: 'Anfang',
      oreA: 'Ende',
      periodo: 'Zeitraum der Abwesenheit',
      orario: 'Anfang - Ende',
      stato: 'Zustand',
      note: 'Notiz',
      dip: 'Mitarb',
      resp: 'Vorgesetzter',
      noteDip: 'Mitarbeiternotizen',
      noteResp: 'Notizen Vorgesetzter',
      ifDelete: 'Löschen bestätigen?',
      attenzione: 'Vorsicht',
      nuovaRichiesta: 'Neu',
      titoloNuovaRichiesta: 'Neuer Freizeitantrag',
      tipologia: 'Freizeitart',
      dataDa: 'Zeitraum',
      dataDa_placeholder: 'von',
      dataA: 'bis',
      oraInizio: 'Beginnzeit',
      oraFine: 'Ende',
      conferma: 'Bestätigen',
      ifInviaRichiesta: 'Je fractionne mon congé principale pour raison personnelle et je renonce donc aux congés de fractionnement inhérents.',
      si: 'Ja',
      no: 'Nein',
      anno: 'Jahr',
      mese: 'Monat',
      vip: 'Vip',
      status: {
        A: 'Versendet',
        C: 'Genehmigt',
        R: 'Abgelehnt',
        T: 'Alle',
        T_des: 'Alles',
        A_des: 'Versendet',
        C_des: 'Genehmigt',
        R_des: 'Abgelehnt'
      },
      noData: 'Keine Dokumente gefunden',
      errorNoPeriodo: 'Geben Sie den Urlaubszeitraum ein',
      autorizzare: 'Zulassen bestätigen?',
      rifiutare: 'Ablehnen bestätigen?',
      d: 'Tage',
      h: 'Std',
      mesi: {
        '01': '{day} januar {year}',
        '02': '{day} februar {year}',
        '03': '{day} märz {year}',
        '04': '{day} april {year}',
        '05': '{day} mai {year}',
        '06': '{day} juni {year}',
        '07': '{day} juli {year}',
        '08': '{day} august {year}',
        '09': '{day} september {year}',
        '10': '{day} oktober {year}',
        '11': '{day} november {year}',
        '12': '{day} dezember {year}'
      },
      hhInizio: 'HH von',
      mmInizio: 'MM von',
      hhFine: 'HH bis',
      mmFine: 'MM bis',
      impiegato: 'Angestellte',
      calend: 'Kalender',
      calendari: {
        calendConge: 'Urlaub',
        authCongeVIP: 'VIP'
      },
      dt_creazione: 'Antragsdatum',
      ggPesati: 'Tage',
      selectAllApp: 'Wählen Sie alle zu genehmigenden Dokumente aus',
      confApp: 'Möchten Sie wirklich alle ausgewählten Freizeit genehmigen?',
      noDocsSel: 'Keine Dokumente ausgewählt'
    },
    presenze: {
      title: 'AN- / Abwesenheiten',
      day: 'Tag',
      hours: 'Stunden',
      causal: 'Grund',
      place: 'Ort',
      company: 'Firma',
      officeDepartment: 'Büro/Abteilung',
      busyness: 'Tätigkeit',
      km: 'Km',
      employee: 'Mitarbeiter',
      date: 'Datum',
      status: 'Land',
      attPred: 'Haupttätigkeit',
      detGio: 'Tagesbericht: {day}',
      chiuso: '[GESCHLOSSEN]',
      aperto: '[ÖFFNEN]',
      confCloseMonth: 'Sind Sie sicher, dass Sie den Monat schließen möchten?',
      confReg: 'Sind Sie sicher, dass Sie die Anwesenheiten erfassen möchten?',
      info: 'Warnung!',
      confValidation: 'Sind Sie sicher, dass Sie die ausgewählten Dokumente bestätigen möchten?',
      confReopening: 'Sind Sie sicher, dass Sie die ausgewählten Dokumente wiederöffnen möchten?'
    },
    calendar: {
      title: 'Kalender',
      anno: 'Jahre',
      mese: 'Monat',
      vip: 'VIP',
      selectVIP: 'Wählen VIP',
      impiegato: 'Angestellte',
      calend: 'Kalender',
      modalGiornoTitolo: 'Anfrage: {nome}',
      note: 'Notiz',
      V: 'Urlaub',
      T: 'Dienstreise',
      all: 'Todos',
      1: 'So',
      2: 'Mo',
      3: 'Di',
      4: 'Mi',
      5: 'Do',
      6: 'Fr',
      7: 'Sa',
      mesi: {
        '01': 'Januar {year}',
        '02': 'Februar {year}',
        '03': 'März {year}',
        '04': 'April {year}',
        '05': 'Mai {year}',
        '06': 'Juni {year}',
        '07': 'Juli {year}',
        '08': 'August {year}',
        '09': 'September {year}',
        '10': 'Oktober {year}',
        '11': 'November {year}',
        '12': 'Dezember {year}'
      },
      toApp: 'Zu Genehmigen',
      groups: 'Gruppe/Team',
      cecoCoi: 'COI-Kostenstelle',
      company: 'Firma',
      prec: 'Vorherige',
      succ: 'Nachfolgend',
      cont: {
        1: {
          0: {
            desc: 'TOT',
            unit: 'tag'
          },
          1: {
            desc: 'JUN',
            unit: 'day'
          },
          2: {
            desc: 'DEZ',
            unit: 'day'
          }
        },
        2: {
          0: {
            desc: 'CP',
            unit: 'tag'
          },
          1: {
            desc: 'CC',
            unit: 'tag'
          },
          2: {
            desc: 'RC',
            unit: 'std'
          }
        },
        3: {
          0: {
            desc: 'VAC',
            unit: 'tag'
          },
          1: {
            desc: 'BH',
            unit: 'std'
          }
        },
        4: {
          0: {
            desc: 'CPL',
            unit: 'tag'
          },
          1: {
            desc: 'CPE',
            unit: 'tag'
          },
          2: {
            desc: 'RHS',
            unit: 'std'
          },
          3: {
            desc: 'RTT',
            unit: 'std'
          }
        },
        5: {
          0: {
            desc: 'UR',
            unit: 'tag'
          }
        }
      }
    },
    trasferte: {
      periodo: 'Dienstreise',
      dataIn: 'Reisebeginn',
      dataFin: 'Reiseende',
      partenza: 'Abreiseort',
      destinazione: 'Reiseziel',
      soc: 'auf Kosten der Firma',
      uffRep: 'Büro/Abteilung',
      referente: 'Ansprechpartner',
      motivo: 'Grund',
      giorno: 'Tag',
      orario: 'Zeitraum',
      notaResp: 'Verantwortliche Notiz',
      authDiary: 'Es werden nur Journalzeilen angezeigt, die vom Standardziel abweichen',
      respAppDiary: 'Sind Sie sicher, dass Sie diese Reihe bestätigen möchten?',
      respRejDiary: 'Sind Sie sicher, dass Sie diese Reihe ablehnen möchten?',
      respAppTrip: 'Sind Sie sicher, dass Sie den Reiseantrag bestätigen möchten?',
      respRejTrip: 'Sind Sie sicher, dass Sie den Reiseantrag ablehnen möchten?',
      info: 'Beachten!',
      mensa: 'Kantine',
      alloggio: 'Unterkunft',
      diario: 'Reiseplan',
      ticket: 'Ticket',
      trasporti: 'Transport',
      auto: 'Firmenfahrzeug',
      doc: 'Dokumenten-Management',
      conformita: {
        titolo: 'Antrag auf Nutzung des Firmenfahrzeugs',
        testo: 'Mit dem Antrag auf Überlassung eines Firmenwagens verpflichtet sich der Arbeitnehmer, diesen unter Einhaltung der betrieblichen Vorschriften zu nutzen, unbeschadet der strikten und gewissenhaften Einhaltung der Straßenverkehrsordnung und aller Vorkehrungen, die erforderlich sind, um die Erhaltung und den Zustand des Firmenwagens zu bewahren.<br><br>Der Arbeitnehmer erklärt ferner, dass er im Besitz einer Fahrerlaubnis ist, die:<ul><li>gültig für die gesamte Dauer der Nutzung</li><li>zum Zeitpunkt der Nutzung nicht ausgesetzt oder entzogen</li><li>zum Führen von Kraftfahrzeugen ohne Leistungs- und/oder Hubraumbeschränkung geeignet ist</li></ul>',
        abort: 'Auftrag wurde abgebrochen'
      },
      tipoTrasferta: 'Art der Dienstreise',
      tipoGio: 'Dienstreise - Tage',
      tipoOre: 'Dienstreise - Stunden',
      numOre: 'Anzahl Stunden',
      to: 'a'
    },
    delSind: {
      anno: 'Année',
      oreLav: 'Hors temps de travail',
      oreLavCell: 'Sur TT',
      giorno: 'Jour',
      oraInizio: 'Heure debut',
      to: 'a',
      delegati: 'Délégués',
      delegato: 'Déléguer',
      periodo: 'Date du-au',
      orario: 'Horaire',
      numOre: 'N. Heures',
      nuovaRichiesta: 'Nouvelle',
      titoloNuovaRichiestaPermesso: 'Nouvelle demande',
      titoloNuovaRichiestaCessione: 'Nouvelle demande de cession des heures',
      tipologia: 'Typologie',
      tipologie: 'Typologies',
      dt_creazione: 'Date Demande',
      ifDelete: 'Confirmer élimination?',
      attenzione: 'Attention',
      btn: {
        pdf: 'Compteurs PDF'
      },
      info: 'Beachten!',
      confCessione: 'Sei sicuro di voler inserire la richiesta? Una volta inserita non sarà più possibile modificarla e/o eliminarla',
      residuo: 'Rückstand'
    },
    ricAuto: {
      data: 'Datum',
      anno: 'Jahr',
      mese: 'Monat',
      tipoAuto: 'Fahrzeugtyp',
      localita: 'Standort',
      orario: 'Zeit',
      oreInizio: 'Startzeit',
      oreFine: 'Endzeit',
      puntoRicarica: 'Ladestation',
      indirizzo: 'Adresse',
      connettore: 'Stecker',
      torretta: 'Säulennummer',
      info: 'Informationen',
      regole: 'Zeitslots',
      newTitle: 'Buchung Hinzufügen',
      delTitle: 'Stornierung der Buchung',
      delMsg: 'Sind Sie sicher, dass Sie diese Anfrage löschen möchten?'
    },
    months: {
      '01': 'Januar',
      '02': 'Februar',
      '03': 'März',
      '04': 'April',
      '05': 'Mai',
      '06': 'Juni',
      '07': 'Juli',
      '08': 'August',
      '09': 'September',
      '10': 'Oktober',
      '11': 'November',
      '12': 'Dezember'
    },
    dashboard: {
      // ITALIA
      resFerRip: 'Residuo Fer/Rip',
      resGiugno: 'Residuo Giugno',
      resDicembre: 'Residuo Dicembre',
      // GERMANIA
      resFerAc: 'Urlaub',
      resFerAp: 'Urlaub Alt',
      resZk1: 'Zeitkonto 1',
      resZk2: 'Zeitkonto 2',
      resZk3: 'Zeitkonto 3',
      resZk4: 'Zeitkonto 4',
      // BELGIO
      saldoCPL: 'Solde CPL',
      saldoRTT: 'Solde RTT',
      saldoCPE: 'Solde CPE',
      saldoRHS: 'Saldo RHS',
      d: 'Tage',
      h: 'Std',
      perc: '%',
      note_5: 'Im Portal beantragte Tage/Std sind bereits verrechnet'
    },
    docs: {
      pubblicazione: 'Publicado el : ',
      scadenza: 'Caduca el:',
      documentType: {
        // ITALIA
        PAIPAGCEDNNU: {
          label: 'Verdienstnachweise'
        },
        PAIPAGTIMNNU: {
          label: 'Zeitjournal'
        },
        PAIPAGLETACN: {
          label: 'Dreizehntes Monatsgehalt'
        },
        PAIPAGLETACC: {
          label: 'Lettera Accompagnatoria'
        },
        PAIPAGMODCUD: {
          label: 'CU'
        },
        // FRANCIA
        PAFPAGCEDNNU: {
          label: 'Verdienstnachweise'
        },
        PAFPAGTIMNNU: {
          label: 'Zeitjournal'
        },
        PAFPAGSITFER: {
          label: 'Urlaubssituation'
        },
        PAFPAGLETGEN: {
          label: 'Generischer Brief'
        },
        PAFPAGLETVAR: {
          label: 'Persönlicher Brief'
        },
        PAFPAGGIOAZI: {
          label: 'Firmenzeitung'
        },
        // SPAGNA
        PAEPAGCEDNNU: {
          label: 'Verdienstnachweise'
        },
        RIVPDEDOCPER: {
          label: 'Dokumentieren'
        },
        RIVPDELETINF: {
          label: 'Krankenstationsdokument'
        },
        // GERMANIA
        RIGPAGCEDNNU: {
          label: 'Verdienstnachweise'
        },
        RIGPAGTIMNNU: {
          label: 'Zeitjournal'
        },
        // BELGIO
        PABPAGTIMNNU: {
          label: 'Zeitjournal'
        },
        PABPAGCEDNNU: {
          label: 'Verdienstnachweise'
        }
      },
      btn: {
        annulla: 'Anular',
        presaVisione: 'Presa Visione',
        leggi: 'Lesen',
        close: 'Schließen',
        download: 'PDF'
      }
    },
    ...deLocale
  },
  en_GB: {
    questions: {
      q1: 'Mother\'s maiden name',
      q2: 'Maternal grandmother\'s maiden name',
      q3: 'Mother\'s birthplace',
      q4: 'Pet name',
      q5: 'Name of the school attended',
      q6: 'Driving license number',
      q7: 'Memorable data',
      q8: 'Memorable place'
    },
    status: {
      all: 'All',
      t: 'Finished',
      0: 'Saved',
      1: 'Forwarded to Manager',
      2: 'Rejected by Manager',
      3: 'Approved',
      4: 'Forwarded to the Secretariat',
      5: 'Rejected by the Secretariat',
      7: 'Cancelled'
    },
    statusDett: {
      0: 'Saved',
      1: 'Forwarded',
      2: 'Rejected', // 'Rifiutata dal Responsabile',
      3: 'Approved', // Approvata alla Segreteria',
      4: 'Forwarded' // Inoltrata alla Segreteria'
    },
    msg: {
      noDocFound: 'No Documents Found',
      abort: 'Operation cancelled'
    },
    placeholder: {
      rangeSeparator: 'to',
      startDate: 'Date from',
      endDate: 'Date End'
    },
    btn: {
      annulla: 'Abort',
      salva: 'Save',
      add: 'Create',
      close: 'Close',
      copyAuto: 'Paste',
      copy: 'Copy',
      paste: 'Paste',
      confermaApp: 'Confirm Approval',
      confermaRej: 'Confirm Reject',
      approva: 'Approve',
      rifiuta: 'Reject',
      nuova: 'New',
      conferma: 'Confirm',
      cerca: 'Search',
      elimina: 'Delete',
      sendAll: 'Forward All',
      sendResp: 'Forward to Manager',
      sendSecretary: 'Secretariat',
      seleziona: 'Select',
      filtri: 'Filters',
      print: 'Print',
      closeMonth: 'Close Month',
      regPresence: 'Register',
      defActivity: 'Default Activity',
      riapri: 'Reopen',
      convalida: 'Validate',
      addActivity: 'Add Activities',
      svuotaCampi: 'Clear Fields',
      yes: 'Yes',
      no: 'No',
      legenda: 'Legend'
    },
    country: {
      label: 'Nations',
      1: 'Italy',
      2: 'France',
      3: 'Spain',
      4: 'Belgium',
      5: 'Germany',
      L: 'Lussemburgo'
    },
    filtri: {
      selFiltri: 'Filters',
      mandatory: 'Mandatory fields',
      selkeyword: 'Please enter a keyword'
    },
    ferie: {
      titolo: 'Management of requests',
      titoloAuth: 'Approve/Refuses',
      titoloCalend: 'Holidays calendar',
      it_resTt: 'Balance',
      it_resGiugno: 'June Balance',
      it_resDicembre: 'Dec Balance',
      fr_resCpNap: 'CP année préc.',
      fr_resCpN: 'CP année cours',
      fr_resRcr: 'RCR',
      fr_resRce: 'RCE',
      es_resVac: 'Vacaciones restantes',
      es_resVacAA: 'Vacaciones año anterior',
      es_resVacAC: 'Vacaciones del año',
      es_resBH: 'Bank hours',
      es_resVac_mobile: 'VAC',
      es_resVacAA_mobile: 'VAC AA',
      es_resVacAC_mobile: 'VAC AC',
      es_resBH_mobile: 'B.H.',
      be_resCpl: 'Conge Legaux JJ',
      be_resCpe: 'Conge Extralegaux JJ',
      be_resRtt: 'RTT HH',
      be_resRhs: 'RHS HH',
      be_resCpl_mobile: 'CPL',
      be_resCpe_mobile: 'CPE',
      be_resRtt_mobile: 'RTT',
      be_resRhs_mobile: 'RHS',
      de_resAc: 'Urlaub',
      de_resAp: 'Urlaub Alt',
      de_resRh1: 'Zeitkonto 1',
      de_resRh2: 'Zeitkonto 2',
      de_resRh3: 'Zeitkonto 3',
      de_resRh4: 'Zeitkonto 4',
      resAc: 'UR',
      resAp: 'UA',
      resRh1: 'Z1',
      resRh2: 'Z2',
      resRh3: 'Z3',
      resRh4: 'Z4',
      tipo: 'Typology',
      dal: 'From',
      al: 'To the',
      to: 'to',
      dataTo: 'to the',
      numOre: 'Num. Hours',
      oreDa: 'Start',
      oreA: 'End',
      periodo: 'Period of Absence',
      orario: 'Start - End',
      oreAssenza: 'Period of Absence',
      stato: 'Status',
      note: 'Note',
      dip: 'Notes Emp.',
      resp: 'Notes Resp.',
      noteDip: 'Employee notes',
      noteResp: 'Responsable notes',
      ifDelete: 'Confirm the deletion?',
      attenzione: 'Attention',
      nuovaRichiesta: 'New',
      titoloNuovaRichiesta: 'New holiday request',
      tipologia: 'Typology',
      dataDa: 'Date from',
      dataDa_placeholder: 'Date from',
      dataA: 'To the',
      oraInizio: 'Start time',
      oraFine: 'end',
      conferma: 'Confirm',
      ifInviaRichiesta: 'Je fractionne mon congé principale pour raison personnelle et je renonce donc aux congés de fractionnement inhérents.',
      si: 'Yes',
      no: 'No',
      anno: 'Year',
      mese: 'Month',
      vip: 'Vip',
      status: {
        A: 'Shipped',
        C: 'Approved',
        R: 'Rejected',
        T: 'All',
        A_des: 'Shipped',
        C_des: 'Approved',
        R_des: 'Rejected',
        T_des: 'All'
      },
      noData: 'No documents found',
      errorNoPeriodo: 'Enter the holiday period',
      autorizzare: 'Confirm Allow?',
      rifiutare: 'Confirm Refuse?',
      d: 'Days',
      h: 'Hours',
      mesi: {
        '01': '{day} january {year}',
        '02': '{day} february {year}',
        '03': '{day} march {year}',
        '04': '{day} april {year}',
        '05': '{day} may {year}',
        '06': '{day} june {year}',
        '07': '{day} july {year}',
        '08': '{day} august {year}',
        '09': '{day} september {year}',
        '10': '{day} october {year}',
        '11': '{day} november {year}',
        '12': '{day} december {year}'
      },
      hhInizio: 'HH start',
      mmInizio: 'MM start',
      hhFine: 'HH end',
      mmFine: 'MM end',
      impiegato: 'Employee',
      calend: 'Calendar',
      calendari: {
        calendConge: 'Holidays',
        authCongeVIP: 'VIP'
      },
      dt_creazione: 'Requested date',
      ggPesati: 'Days',
      selectAllApp: 'Select all documents to Approve',
      confApp: 'Are you sure you want to Approve all selected absences?',
      noDocsSel: 'No documents selected'
    },
    presenze: {
      title: 'WEB Attendance',
      day: 'Day',
      hours: 'Hours',
      causal: 'Causal',
      place: 'Location',
      company: 'Company',
      officeDepartment: 'Office / Department',
      busyness: 'Activity',
      km: 'Km',
      employee: 'Employee',
      date: 'Date',
      status: 'Status',
      attPred: 'DEFAULT ACTIVITY',
      detGio: 'Daily Detail: {day}',
      closed: '[CLOSED]',
      open: '[ OPEN ]',
      confCloseMonth: 'Are you sure you want to Close the Month?',
      confReg: 'Are you sure you want to Record Attendance?',
      info: 'Warning!',
      confValidation: 'Are you sure you want to Validate the selected documents?',
      confReopening: 'Are you sure you want to Reopen the selected documents?'
    },
    calendar: {
      title: 'Calendar',
      anno: 'Year',
      mese: 'Month',
      vip: 'VIP',
      selectVIP: 'Select VIP',
      impiegato: 'Employee',
      calend: 'Calendar',
      modalGiornoTitolo: 'Employee: {nome}',
      note: 'Note',
      V: 'Holiday',
      T: 'Business Trip',
      all: 'All',
      1: 'Mo',
      2: 'Tu',
      3: 'We',
      4: 'Th',
      5: 'Fr',
      6: 'Sa',
      7: 'Su',
      mesi: {
        '01': 'January {year}',
        '02': 'February {year}',
        '03': 'March {year}',
        '04': 'April {year}',
        '05': 'May {year}',
        '06': 'June {year}',
        '07': 'July {year}',
        '08': 'August {year}',
        '09': 'September {year}',
        '10': 'October {year}',
        '11': 'November {year}',
        '12': 'December {year}'
      },
      toApp: 'To be approved',
      groups: 'Group/Team',
      cecoCoi: 'COI Cost Center',
      company: 'Company',
      prec: 'Previous',
      succ: 'Next',
      cont: {
        1: {
          0: {
            desc: 'TOT',
            unit: 'day'
          },
          1: {
            desc: 'JUN',
            unit: 'day'
          },
          2: {
            desc: 'DEC',
            unit: 'day'
          }
        },
        2: {
          0: {
            desc: 'CP',
            unit: 'day'
          },
          1: {
            desc: 'CC',
            unit: 'day'
          },
          2: {
            desc: 'RC',
            unit: 'hh'
          }
        },
        3: {
          0: {
            desc: 'VAC',
            unit: 'day'
          },
          1: {
            desc: 'BH',
            unit: 'hh'
          }
        },
        4: {
          0: {
            desc: 'CPL',
            unit: 'day'
          },
          1: {
            desc: 'CPE',
            unit: 'day'
          },
          2: {
            desc: 'RHS',
            unit: 'hh'
          },
          3: {
            desc: 'RTT',
            unit: 'hh'
          }
        },
        5: {
          0: {
            desc: 'UR',
            unit: 'tag'
          }
        }
      }
    },
    trasferte: {
      title: 'Business Trip',
      periodo: 'Periodo',
      dataIn: 'Data Inizio',
      dataFin: 'Data Fine',
      partenza: 'Partenza',
      destinazione: 'Destinazione',
      soc: 'Per conto della Società',
      uffRep: 'Ufficio/Reparto',
      referente: 'Persona di Riferimento',
      motivo: 'Motivazione',
      giorno: 'Giorno',
      orario: 'Orario',
      notaResp: 'Nota Responsabile',
      authDiary: 'Vengono visualizzate solo le righe del diario che differiscono dalla destinazione di default',
      respAppDiary: 'Sei sicuro di voler Approvare la riga di Diario?',
      respRejDiary: 'Sei sicuro di voler Rifiutare la riga di Diario?',
      respAppTrip: 'Sei sicuro di voler Approvare la Trasferta',
      respRejTrip: 'Sei sicuro di voler Rifiutare la Trasferta',
      info: 'Warning!',
      mensa: 'Canteen',
      alloggio: 'Accommodation',
      diario: 'Travel Diary',
      ticket: 'Ticket',
      trasporti: 'Transport',
      auto: 'Company Vehicle',
      doc: 'Documents',
      conformita: {
        titolo: 'Request for use of company vehicle',
        testo: 'To proceed with the request for assignment of a company vehicle, the employee undertakes to use it in compliance with company regulations, while strictly and conscientiously adhering to traffic laws and taking all necessary precautions to preserve its condition and state.<br><br>Furthermore, the employee declares to hold a driving licence that:<ul><li>is valid for the entire duration of use</li><li>is not subject to suspension or revocation</li><li>is suitable for driving cars without restrictions on power and/or engine capacity</li></ul>',
        abort: 'Operation Cancelled'
      },
      tipoTrasferta: 'Travel Type',
      tipoGio: 'Daily Travel',
      tipoOre: 'Hourly Travel',
      numOre: 'Num. Hours',
      to: 'a'
    },
    delSind: {
      anno: 'Année',
      oreLav: 'Hors temps de travail',
      oreLavCell: 'Sur TT',
      giorno: 'Jour',
      oraInizio: 'Heure debut',
      to: 'a',
      delegati: 'Délégués',
      delegato: 'Déléguer',
      periodo: 'Date du-au',
      orario: 'Horaire',
      numOre: 'Num. Hours',
      nuovaRichiesta: 'Nouvelle',
      titoloNuovaRichiestaPermesso: 'Nouvelle demande',
      titoloNuovaRichiestaCessione: 'Nouvelle demande de cession des heures',
      tipologia: 'Typologie',
      tipologie: 'Typologies',
      dt_creazione: 'Date Demande',
      ifDelete: 'Confirmer élimination?',
      attenzione: 'Attention',
      btn: {
        pdf: 'Compteurs PDF'
      },
      info: 'Warning!',
      confCessione: 'Sei sicuro di voler inserire la richiesta? Una volta inserita non sarà più possibile modificarla e/o eliminarla',
      residuo: 'Residue'
    },
    ricAuto: {
      data: 'Date',
      anno: 'Year',
      mese: 'Month',
      tipoAuto: 'Vehicle Type',
      localita: 'Location',
      orario: 'Time',
      oreInizio: 'Start Time',
      oreFine: 'End Time',
      puntoRicarica: 'Charging Point',
      indirizzo: 'Address',
      connettore: 'Connector',
      torretta: 'Post Number',
      info: 'Info',
      regole: 'Time Slots',
      newTitle: 'Add Reservation',
      delTitle: 'Reservation cancellation',
      delMsg: 'Are you sure you want to delete this request?'
    },
    months: {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      '10': 'October',
      '11': 'November',
      '12': 'December'
    },
    dashboard: {
      // ITALIA
      resFerRip: 'Residuo Fer/Rip',
      resGiugno: 'Residuo Giugno',
      resDicembre: 'Residuo Dicembre',
      // GERMANIA
      resFerAc: 'Urlaub',
      resFerAp: 'Urlaub Alt',
      resZk1: 'Zeitkonto 1',
      resZk2: 'Zeitkonto 2',
      resZk3: 'Zeitkonto 3',
      resZk4: 'Zeitkonto 4',
      // BELGIO
      saldoCPL: 'Solde CPL',
      saldoRTT: 'Solde RTT',
      saldoCPE: 'Solde CPE',
      saldoRHS: 'Saldo RHS',
      d: 'Days',
      h: 'Hours',
      perc: '%',
      note_5: 'The days/hours requested on the portal have already been charged'
    },
    docs: {
      pubblicazione: 'Publicado el : ',
      scadenza: 'Caduca el:',
      documentType: {
        // ITALIA
        PAIPAGCEDNNU: {
          label: 'Payslip'
        },
        PAIPAGTIMNNU: {
          label: 'Time card'
        },
        PAIPAGLETACN: {
          label: 'Thirteenth month\'s salary'
        },
        PAIPAGLETACC: {
          label: 'Cover letter'
        },
        PAIPAGMODCUD: {
          label: 'CU'
        },
        // FRANCIA
        PAFPAGCEDNNU: {
          label: 'Payslip'
        },
        PAFPAGTIMNNU: {
          label: 'Time card'
        },
        PAFPAGSITFER: {
          label: 'Holiday situation'
        },
        PAFPAGLETGEN: {
          label: 'Generic Letter'
        },
        PAFPAGLETVAR: {
          label: 'Personal Letter'
        },
        PAFPAGGIOAZI: {
          label: 'Company newspaper'
        },
        // SPAGNA
        PAEPAGCEDNNU: {
          label: 'Payslip'
        },
        RIVPDEDOCPER: {
          label: 'Document'
        },
        RIVPDELETINF: {
          label: 'Infirmary Document'
        },
        // BELGIO
        PABPAGTIMNNU: {
          label: 'Time card'
        },
        PABPAGCEDNNU: {
          label: 'Payslip'
        },
        // GERMANIA
        RIGPAGCEDNNU: {
          label: 'Payslip'
        },
        RIGPAGTIMNNU: {
          label: 'Time card'
        }
      },
      btn: {
        annulla: 'Anular',
        presaVisione: 'Presa Visione',
        leggi: 'Read',
        close: 'Close',
        download: 'PDF'
      }
    }
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/assets/Traduzioni.js